// extracted by mini-css-extract-plugin
module.exports = {"content":"content___354pt","mobileView":"mobileView___2NUdE"};